import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Container, Section, Grid, Button } from "../components/ui";
import SEO from "../components/SEO";

const PageHeader = styled.div`
  text-align: center;
  padding: 4rem 0;
  background: #f9fafb;
`;

const PageTitle = styled.h1`
  margin-bottom: 1rem;
`;

const PageDesc = styled.p`
  color: #6b7280;
  font-size: 1.125rem;
  max-width: 600px;
  margin: 0 auto;
`;

const ArticleCard = styled.div`
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
`;

const ArticleIcon = styled.div`
  height: 160px;
  background: ${({ $color }) => $color || '#fef3c7'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
`;

const ArticleContent = styled.div`
  padding: 1.5rem;
`;

const ArticleTitle = styled.h3`
  margin-bottom: 0.75rem;
`;

const ArticleDesc = styled.p`
  color: #6b7280;
  line-height: 1.625;
  margin: 0;
`;

const CTASection = styled.div`
  text-align: center;
  background: linear-gradient(135deg, #fef3c7 0%, #ffffff 100%);
  padding: 4rem 2rem;
  border-radius: 1rem;
  margin-top: 4rem;
`;

const articles = [
  {
    icon: "📐",
    color: "#e0f2fe",
    title: "Time is Measurement",
    description: "Time, in its simplest form, is a measurement of distance. Humans developed time as a concept to track significant moments in Earth's orbit—the day, the full moon, and the year. Until The New Calendar, time was the only measurement system built before the Scientific Revolution.",
  },
  {
    icon: "📊",
    color: "#dcfce7",
    title: "Time is Data",
    description: "Time is the measurement we use to capture changes across long distances—weeks, months, years, decades. To capture meaningful data, a measurement system must contain uniform, logical units. A system with months of 28, 30, and 31 days makes comparison nearly impossible without painstaking adjustments.",
  },
  {
    icon: "💰",
    color: "#fef3c7",
    title: "Time is Money",
    description: "Time is money: measure it well and spend it wisely. Time is the most precious resource that every person has equal access to daily. How efficiently and effectively a person manages their time is crucial to wealth, health, and happiness. The New Calendar helps users organize time in the most precise, accurate, and logical system ever developed.",
  },
];

const Blog = () => {
  return (
    <>
      <SEO
        title="Blog - It's About Time"
        description="Learn about the science of time. Time is measurement, time is data, time is money."
        url="https://thenewcalendar.com/blog"
      />

      <PageHeader>
        <Container>
          <PageTitle>It's About Time</PageTitle>
          <PageDesc>
            Understanding why time—as we've measured it for millennia—is fundamentally broken, 
            and how The New Calendar fixes it.
          </PageDesc>
        </Container>
      </PageHeader>

      <Section>
        <Container>
          <Grid cols={3} gap="2rem">
            {articles.map((article, i) => (
              <ArticleCard key={i}>
                <ArticleIcon $color={article.color}>{article.icon}</ArticleIcon>
                <ArticleContent>
                  <ArticleTitle>{article.title}</ArticleTitle>
                  <ArticleDesc>{article.description}</ArticleDesc>
                </ArticleContent>
              </ArticleCard>
            ))}
          </Grid>

          <CTASection>
            <h2 style={{ marginBottom: '1rem' }}>Ready to rethink time?</h2>
            <p style={{ color: '#6b7280', marginBottom: '1.5rem', maxWidth: '480px', margin: '0 auto 1.5rem' }}>
              Join the revolution. Get a calendar that actually makes sense.
            </p>
            <Button as={Link} to="/shop" size="lg">
              Shop Now
            </Button>
          </CTASection>
        </Container>
      </Section>
    </>
  );
};

export default Blog;
